import { LocaleConstants } from '../constants';

export const switchLanguage = (lang) => (
  {
    type: LocaleConstants.SWITCH_LANGUAGE,
    payload: lang,
  }
);
